// extracted by mini-css-extract-plugin
module.exports = {"Marker":"styles_Marker__2FZ-R","mover":"styles_mover__3lJlO"};